import api from "./api";

export const getAssignments = (courseId) => api.get(`/assignments/course/${courseId}`);
export const createAssignment = (data) => api.post(`/assignments`, data);
export const submitAssignment = (assignId, data) => api.post(`/assignments/${assignId}/submit`, data);
export const getSubmissions = (assignId) => api.get(`/assignments/${assignId}/submissions`);
export const gradeSubmission = (subId, data) => api.post(`/assignments/submissions/${subId}/grade`, data);
